var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-center"},[_vm._v("\n    碳减排量\n    "),_vm._l((_vm.number),function(item,i){return _c('div',{key:'output' + i,staticClass:"number"},[_vm._v("\n        "+_vm._s(item)+"\n    ")])}),_vm._v("\n    CC\n")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }